<a style="cursor: pointer" (click)="clickPaginaAnterior()" aria-label="Previous" class="mr-2">
  <img src="assets/img/global/left-24.png" alt="anterior" height="20" width="20">
</a>
<span class="mr-1">{{paginaCorrente}} de</span>
<span class="ml-1">{{paginaTotal}} </span>
<a style="cursor: pointer" (click)="clickProximaPagina()" aria-label="Next" class="ml-2">
  <img src="assets/img/global/right-24.png" alt="próximo" height="20" width="20">
</a>
